export const HOTSTAR_URL = "https://www.jiohotstar.com/";

// Single source of truth for contestant imagery.
// Replace only the `img` values with the image URLs used by the voting options.
export const CURRENT_SEASON_NUMBER = 13;
export const CURRENT_PHONE = "+918886650451";

const placeholder = (name) =>
  `https://placehold.co/720x960/101323/F5F7FF?text=${encodeURIComponent(name)}`;

const contestant = (name, profession, bio = "Bigg Boss Kannada housemate.", img = null) => ({
  id: name.toLowerCase().replace(/[^a-z0-9]+/g, "-"),
  name,
  profession,
  bio,
  img: img || placeholder(name),
});

export const season13Contestants = [
  contestant("Jagadish MB", "Actor", "Kannada actor popularly known as Jaggu Mamma from Love Mocktail 3.", "https://cdn.strawpoll.com/images/polls/options/GPgVGPLvZaE-c.png"),
  contestant("Soundarya Shetty", "Model & content creator", "Model, content creator and reality television personality.", "https://cdn.strawpoll.com/images/polls/options/bVg8Nm8eyYa-c.png"),
  contestant("Om Prakash Rao", "Actor & director", "Veteran Kannada actor and director entering the Season 13 house.", "https://cdn.strawpoll.com/images/polls/options/BJnX3xLYyvV-c.png"),
  contestant("Sangeetha Bhat", "Actress", "Kannada actress known for television and screen roles.", "https://cdn.strawpoll.com/images/polls/options/05ZdYaRby6P-c.png"),
  contestant("Kavya Gowda", "Television actress", "Kannada television actress and model.", "https://cdn.strawpoll.com/images/polls/options/eNg6QEDAnAk-c.png"),
  contestant("Asiya Firdose", "Television actress", "Kannada television actress and Season 13 housemate.", "https://cdn.strawpoll.com/images/polls/options/PbZqGLQBnN1-c.png"),
  contestant("Vaishnavi Kaundinya", "Television actress", "Kannada television actress and performer.", "https://cdn.strawpoll.com/images/polls/options/2ayLp56vy4k-c.png"),
  contestant("Tandav Ram", "Actor", "Kannada actor competing in Season 13.", "https://cdn.strawpoll.com/images/polls/options/GeZAkpmknV5-c.png"),
  contestant("Gagan Chikappa", "Actor", "Kannada actor and entertainer.", "https://cdn.strawpoll.com/images/polls/options/61gDz325ywd-c.png"),
  contestant("Yashas Krishna", "Actor", "Kannada actor and Season 13 contestant.", "https://cdn.strawpoll.com/images/polls/options/X3nk5pdjZEP-c.png"),
  contestant("Avinash Shatamarshan", "Actor", "Actor and entertainer entering the Season 13 house.", "https://cdn.strawpoll.com/images/polls/options/kjn1kRWdZQe-c.png"),
  contestant("Prathama Prasad", "Reality-show contestant", "Contestant selected through the Bigg Boss Agnipariksha route.", "https://cdn.strawpoll.com/images/polls/options/B2ZBJjzxZJq-c.png"),
  contestant("Dhanush", "Record holder & performer", "Agnipariksha contestant and Guinness World Record holder.", "https://cdn.strawpoll.com/images/polls/options/ajnEa5WBnWV-c.png"),
  contestant("Manja", "Agnipariksha contestant", "Fresh entrant selected through the Bigg Boss Agnipariksha process.", "https://cdn.strawpoll.com/images/polls/options/40ZmoNx2naR-c.png"),
  contestant("Kiran Shastry", "Agnipariksha contestant", "Fresh entrant selected through the Bigg Boss Agnipariksha process.", "https://cdn.strawpoll.com/images/polls/options/e7ZJeBLKg3K-c.png"),
  contestant("Likith Gondhi", "Agnipariksha contestant", "Fresh entrant selected through the Bigg Boss Agnipariksha process.", "https://cdn.strawpoll.com/images/polls/options/XOgOwD6Gg3o-c.png"),
];

export const seasonArchives = [
  {
    number: 1, year: 2013, title: "Bigg Boss Kannada Season 1", theme: "Howdu Swami!", host: "Sudeep",
    winner: "Vijay Raghavendra", runnerUp: "Arun Sagar", days: 98,
    contestants: [
      "Narendra Babu Sharma", "Leelavathi S M", "Arun Sagar", "Shwetha Pandit", "Vinayak Joshi", "Aparna", "Anushree", "Thilak Shekar", "Nikitha Thukral", "Vijay Raghavendra", "Chandrika", "Jayalakshmi", "Rishi Kumar", "Rohan Gowda", "Rishika Singh"
    ],
  },
  {
    number: 2, year: 2014, title: "Bigg Boss Kannada Season 2", theme: "Thamashene Alla!", host: "Sudeep",
    winner: "Akul Balaji", runnerUp: "Srujan Lokesh", days: 98,
    contestants: [
      "Akul Balaji", "Deepika Kamaiah", "Laya Kokolla", "Harshika Poonacha", "Santhosh", "Neethu Shetty", "Anitha Bhat", "Srujan Lokesh", "Rohith Patel", "Shweta Chengappa", "Mayur Patel", "Anupama Bhat", "Aadhi Lokesh", "Guruprasad", "Shakeela", "Shakila"
    ],
  },
  {
    number: 3, year: 2015, title: "Bigg Boss Kannada Season 3", theme: "Naatakakke Illi Jaaga Illa!", host: "Sudeep",
    winner: "Shruti", runnerUp: "Chandan Kumar", days: 98,
    contestants: [
      "Bhavana Belagere", "Chandan Kumar", "Huccha Venkat", "Shalini Satyanarayan", "Kruthika Ravindra", "Master Anand", "Neravanda Aiyappa", "Rehman Haseeb", "Neha Gowda", "Pooja Gandhi", "Tsunami Kitty", "Ravi Mooruru", "Mithra", "RJ Nethra", "Jayashree", "Gowthami Gowda", "Shruthi", "Madhuri"
    ],
  },
  {
    number: 4, year: 2016, title: "Bigg Boss Kannada Season 4", theme: "Kandiro Mukhagala Kanade Iro Mukha!", host: "Sudeep",
    winner: "Pratham", runnerUp: "Kirik Keerthi", days: 112,
    contestants: [
      "Pratham", "Sheetal Shetty", "Malavika Avinash", "Kirik Keerthi", "Sihi Kahi Chandru", "Murali", "Jai Jagadish", "Bhuvan Ponnanna", "Sanjana Chidanand", "Dodda Ganesh", "Vanishree", "Niranjan Deshpande", "Karunya Ram", "Mohan Shankar", "Rekha", "Shalini Satyanarayan", "Om Prakash Rao", "Sukrutha Wagle"
    ],
  },
  {
    number: 5, year: 2017, title: "Bigg Boss Kannada Season 5", theme: "No Tagline", host: "Sudeep",
    winner: "Chandan Shetty", runnerUp: "Diwakar", days: 105,
    contestants: [
      "Jaya Sreenivasan", "Megha", "Dayal Padmanabhan", "Sihi Kahi Chandru", "Anupama Gowda", "Riyaz Basha", "Niveditha Gowda", "Sameer Acharya", "Karthik Jayaram", "Diwakar", "Karthik", "Shruthi Prakash", "Lasya Nagraj", "Samyuktha Hegde", "Jagan Chandrashekhar", "Ashitha Chandrappa", "Vaishnavi", "Chandan Shetty", "Tejaswini Prakash", "Suma Rajkumar"
    ],
  },
  {
    number: 6, year: 2018, title: "Bigg Boss Kannada Season 6", theme: "Ice-Fire", host: "Sudeep",
    winner: "Shashi Kumar", runnerUp: "Naveen Sajju", days: 100,
    contestants: [
      "Shashi Kumar", "Naveen Sajju", "Kavitha Gowda", "Andrew Jaypaul", "Rapid Rashmi", "Dhanraj", "Rakesh", "Akshatha Pandavapura", "Muruli Dabbi", "Jeevitha Sagar", "Meghashree", "Jayashree Raj", "Naina Puttaswamy", "Sonu Patil", "Anand Malgatti", "Ravi AV", "Adam Pasha", "Sneha Acharya", "Reema Dias", "Rakshitha Rai"
    ],
  },
  {
    number: 7, year: 2019, title: "Bigg Boss Kannada Season 7", theme: "All Celebrity", host: "Sudeep",
    winner: "Shine Shetty", runnerUp: "Kuri Pratap", days: 112,
    contestants: [
      "Kuri Pratap", "Priyanka Shivanna", "Ravi Belagere", "Chandana Ananthakrishna", "Vishwanath Haveri", "Deepika Das", "Jai Jagadish", "Gurulinga Swamy", "Bhoomi Shetty", "Kishan Belagali", "Chandan Achar", "Raju Talikote", "Sujatha Satyanarayan", "Chaitra Vasudevan", "Shine Shetty", "Chaitra Kotooru", "Chakravarthy Chandrachud", "Duniya Rashmi", "Prithvi", "Raksha Somashekar"
    ],
  },
  {
    number: 8, year: 2021, title: "Bigg Boss Kannada Season 8", theme: "Second Innings", host: "Sudeep",
    winner: "Manju Pavagada", runnerUp: "Aravind KP", days: 117,
    contestants: [
      "Dhanushree", "Shubha Poonja", "Shankar Ashwath", "Vishwanath Haveri", "Vaishnavi Gowda", "Aravind KP", "Nidhi Subbaiah", "Shamanth Gowda", "Geetha Bharathi Bhat", "Manju Pavagada", "Nirmala Chennappa", "Raghu Gowda", "Divya Suresh", "Divya Uruduga", "Chandrakala Mohan", "Prashanth Sambargi", "Rajeev Hanu", "Chakravarthy Chandrachud", "Vyjayanthi Adiga", "Priyanka Thimmesh"
    ],
  },
  {
    number: 9, year: 2022, title: "Bigg Boss Kannada Season 9", theme: "Ranarangam", host: "Sudeep",
    winner: "Roopesh Shetty", runnerUp: "Rakesh Adiga", days: 98,
    contestants: [
      "Arun Sagar", "Mayuri Kyatari", "Deepika Das", "Nawaz", "Rupesh Rajanna", "Divya Uruduga", "Kavyashree Gowda", "Vinod Gobbaragala", "Saanya Iyer", "Neha Gowda", "Darsh Chandrappa", "Prashanth Sambargi", "Aishwarya Pissay", "Rakesh Adiga", "Roopesh Shetty", "Aryavardhan", "Anupama Gowda", "Amulya Gowda"
    ],
  },
  {
    number: 10, year: 2023, title: "Bigg Boss Kannada Season 10", theme: "Bigg Boss 10", host: "Sudeep",
    winner: "Karthik Mahesh", runnerUp: "Drone Prathap", days: 111,
    contestants: [
      "Namratha Gowda", "Snehith Gowda", "Eshani Chandrashekar", "Vinay Gowda", "Drone Prathap", "Santhosh Kumar", "SRK", "Binny Joseph", "Tanisha Kuppanda", "Neethu Vanajakshi", "Siri Sirija", "Rakshak Bullet", "Sangeetha Sringeri", "Snake Shyam", "Varthur Santhosh", "Bhagyashree Rao", "Gaurish Akki", "Michael Ajay", "Karthik Mahesh", "Avinash Shetty", "Pavi Poovappa"
    ],
  },
  {
    number: 11, year: 2024, title: "Bigg Boss Kannada Season 11", theme: "Swarga and Naraka", host: "Kiccha Sudeepa",
    winner: "Hanumantha Lamani", runnerUp: "Trivikram", days: 119,
    contestants: [
      "Yamuna Srinidhi", "Bhavya Gowda", "Dhanraj Achar", "Gauthami Jadav", "Jagadish", "Dharma Keerthiraj", "Anusha Rai", "Shishir Shastry", "Trivikram", "Hamsa Prathap", "Tukali Manasa", "Gold Suresh", "Aishwarya Shindogi", "Chaitra Kundapura", "Hanumantha Lamani", "Rajath", "Mokshita", "Manju", "Dhanraj", "Gouthami"
    ],
  },
  {
    number: 12, year: 2025, title: "Bigg Boss Kannada Season 12", theme: "Onti and Janti", host: "Kiccha Sudeepa",
    winner: "Gilli Nata", runnerUp: "Rakshita Shetty", days: 112,
    contestants: [
      "Sudhir Balraj", "Kavya Shaiva", "Satish Cadaboms", "Gilli Nata", "Jahnvi", "Dhanush Gowda", "Chandra Prabha", "Manju Bhashini", "Rashika Shetty", "Abhishek", "Mallamma", "Ashvini S", "Dhruvanth", "Rakshita Shetty", "Karibasappa", "Malu", "Spandana", "Ashwini Gowda", "Amith", "Raghu", "Suraj", "Chaitra", "Risha", "RJ Amith"
    ],
  },
];

export const season9ImageMap = {
  "Demon Pavan": "https://cdn.strawpoll.com/images/polls/options/GJn4QGeqgzm-c.png",
  "Emmanuel": "https://cdn.strawpoll.com/images/polls/options/1Mnwrvq5y7D-c.png",
  "Thanuja Puttaswamy": "https://cdn.strawpoll.com/images/polls/options/wby5ole7gAe-c.png",
  "Kalyan Padala": "https://cdn.strawpoll.com/images/polls/options/NMnQJBGAg6Y-c.png",
  "Divya Nikitha": "https://cdn.strawpoll.com/images/polls/options/DwyoLqwNnAz-c.png",
  "Bharani Shankar": "https://cdn.strawpoll.com/images/polls/options/BDyNdjL7gRO-c.png",
  "Suman Shetty": "https://cdn.strawpoll.com/images/polls/options/YVyPE2BAnNd-c.png",
  "Rithu Chowdary": "https://cdn.strawpoll.com/images/polls/options/poy9KRNwgJr-c.png",
  "Nikhil Nair": "https://cdn.strawpoll.com/images/polls/options/kjn14jWAyQe-c.png",
  "Gaurav Gupta": "https://cdn.strawpoll.com/images/polls/options/eJnvR7oanv4-c.png",
  "Sanjjanaa Galrani": "https://cdn.strawpoll.com/images/polls/options/bVg8P68BgYa-c.png",
};